import React from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { makeStyles } from "@mui/styles";
import PropTypes from "prop-types";

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const useStyles = makeStyles(() => ({
    root: {
        width: "100%",
        "& > * + *": {
            marginTop: 8, // simple fixed spacing
        },
    },
}));

function CustomSnackbar({ message, open, severity, handleClose }) {
    const classes = useStyles();

    const onClose = (event, reason) => {
        if (reason === "clickaway") return; // ignore accidental outside clicks
        handleClose();
    };

    return (
        <div className={classes.root}>
            <Snackbar
                open={open}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                autoHideDuration={6000}
                onClose={onClose}
            >
                <Alert onClose={onClose} severity={severity || "info"} sx={{ width: "100%" }}>
                    {message || ""}
                </Alert>
            </Snackbar>
        </div>
    );
}

CustomSnackbar.propTypes = {
    message: PropTypes.string, // ✅ not required anymore
    open: PropTypes.bool.isRequired,
    severity: PropTypes.oneOf(["error", "warning", "info", "success"]),
    handleClose: PropTypes.func.isRequired,
};

export default CustomSnackbar;
